import BlurredBackground from "./BlurredBackground"
export default BlurredBackground
